// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__dYi7G","subheader":"ReorderModal_subheader__3IcYp","listWrap":"ReorderModal_listWrap__2nZr2"};